import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPlantTypesInputDto, PlantTypeCreateDto, PlantTypeDto, PlantTypeExcelDownloadDto, PlantTypeUpdateDto } from '../dtos/plant-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PlantTypeService {
  private restService = inject(RestService);
  apiName = 'General';
  

  create = (input: PlantTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantTypeDto>({
      method: 'POST',
      url: '/api/general/plantTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/general/plantTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/general/plantTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantTypeDto>({
      method: 'GET',
      url: `/api/general/plantTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/general/plantTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPlantTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PlantTypeDto>>({
      method: 'GET',
      url: '/api/general/plantTypes',
      params: { name: input.name, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PlantTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/general/plantTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantTypeDto[]>({
      method: 'GET',
      url: '/api/general/plantTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PlantTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantTypeDto>({
      method: 'PUT',
      url: `/api/general/plantTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}